import { LEAD_TYPE_ID, SUBSCRIPTION_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getEditDefaultActionsData, getPreviewDefaultActionsData, getPrimaryDefaultActionsData, getRemoveDefaultActionsData } from '../default/getDefaultChickletHoverActions';

/**
 * Determines whether to show the edit association labels action and returns the appropriate data
 */
import { jsx as _jsx } from "react/jsx-runtime";
const getEditAssociationActionData = args => {
  const {
    fromObjectTypeId
  } = args;
  switch (fromObjectTypeId) {
    case LEAD_TYPE_ID:
      return undefined;
    default:
      return getEditDefaultActionsData(args);
  }
};

/**
 * Determines whether to disable the remove association action and returns the appropriate data
 */
const getRemoveAssociationActionData = args => {
  const {
    fromObjectTypeId,
    primaryAssociationObjectId,
    objectId
  } = args;
  switch (fromObjectTypeId) {
    case LEAD_TYPE_ID:
      if (objectId === primaryAssociationObjectId) {
        return getRemoveDefaultActionsData(args, {
          disabled: true,
          disabledMessage: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "cardAssociatedObjects.chicklet.ChickletHoverActionsDropdown.disabledRemovePrimaryContactAssociationFromLeadTooltip"
          })
        });
      }
      return getRemoveDefaultActionsData(args);
    case SUBSCRIPTION_TYPE_ID:
      return getRemoveDefaultActionsData(args, {
        disabled: true,
        disabledMessage: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardAssociatedObjects.chicklet.ChickletHoverActionsDropdown.disabledSubscriptionToContactTooltip"
        })
      });
    default:
      return getRemoveDefaultActionsData(args);
  }
};
const useActions = args => {
  return {
    PrimaryAction: getPreviewDefaultActionsData(args),
    SecondaryActions: [getPrimaryDefaultActionsData(args), getEditAssociationActionData(args), getRemoveAssociationActionData(args)]
  };
};
export default useActions;